import React from "react";
import { useSearchParams } from "react-router-dom";
import ProductListingPage from "../components/ProductListing";

const SearchResultsPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const searchQuery = searchParams.get("q") || "";

    return <ProductListingPage mode="search" searchQuery={searchQuery} />;
};

export default SearchResultsPage;
